import { z } from 'zod';
export const PIN_LENGTH = 6;
/** 6-stellige Ziffern-PIN fuer den Kinder-Login (SPEC 2). */
export const pinSchema = z
    .string()
    .regex(new RegExp(`^\\d{${PIN_LENGTH}}$`), `PIN muss aus ${PIN_LENGTH} Ziffern bestehen`);
export const passwordSchema = z
    .string()
    .min(12, 'Passwort muss mindestens 12 Zeichen lang sein')
    .max(256);
/**
 * Login entweder mit Passwort oder mit PIN. `identifier` ist Name oder E-Mail,
 * damit Kinder ohne E-Mail-Adresse auskommen.
 */
export const loginSchema = z
    .object({
    identifier: z.string().min(1, 'Name oder E-Mail angeben').max(254),
    password: z.string().min(1).max(256).optional(),
    pin: pinSchema.optional(),
})
    .refine((v) => Boolean(v.password) !== Boolean(v.pin), {
    message: 'Entweder Passwort oder PIN angeben',
    path: ['password'],
});
//# sourceMappingURL=auth.js.map